export default "__VITE_ASSET__ccb58273__"